import React from "react";

export const PauseIcon = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg fill="currentColor" height="16" stroke="currentColor" viewBox="0 0 16 16" width="16" {...props}>
    <path d="M5 4V12" stroke="currentColor" strokeLinecap="round" strokeWidth="2.5" />
    <path d="M11 4V12" stroke="currentColor" strokeLinecap="round" strokeWidth="2.5" />
  </svg>
);
